export function backButtonFunctionality() {
  // Select all .go-back-button elements
  [...document.querySelectorAll('.go-back-button')].forEach(button => {
    // Attach the click event listener to each button
    button.addEventListener('click', function() {
      history.back();
    });
  });
}

